import { render } from "./LbrxOrderCheckout.vue?vue&type=template&id=52fb1b0a"
import script from "./LbrxOrderCheckout.vue?vue&type=script&lang=js"
export * from "./LbrxOrderCheckout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__